module.exports = "<ui-view name=\"menu\"></ui-view>\n<ui-view name=\"content\"></ui-view>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.html
// module id = 1480
// module chunks = 0